module.exports = ".error-message{background-color:#E41736;color:#fff;font-size:16px;display:inline-block;padding:5px 10px;border-radius:10px}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/accounts/delete-account/delete-account.component.scss
// module id = 793
// module chunks = 0